import React, { Children, useEffect, useState, useRef } from "react";
import { updateToolSettings, getToolSettings } from "../API";
import _forOwn from "lodash/forOwn";
import _ from "lodash";
import HelperService from "../Helpers/HelperService";
import {
  sensorLive,
  channelColors,
  toolSyncTime,
  Colors,
  Metrics,
} from "../global";
import { View, Dashboard, Row } from "../Components";
import { Row as ViewRow } from "antd";
// import { Colors, Helpers, Metrics, Fonts } from 'App/Theme'
// import NavigationService from 'App/Services/NavigationService'
// import { useFocusEffect } from '@react-navigation/native'
import { ReactComponent as toolIcon } from "../Assets/SVG/4Ch_Big.svg";
// import { getAllGraphData } from 'App/Stores/Tools/Selectors'
import { ReactComponent as ch1Icon } from "../Assets/SVG/Ch1.svg";
import { ReactComponent as ch2Icon } from "../Assets/SVG/Ch2.svg";
import { ReactComponent as ch3Icon } from "../Assets/SVG/Ch3.svg";
import { ReactComponent as ch4Icon } from "../Assets/SVG/Ch4.svg";
import { ReactComponent as ambIcon } from "../Assets/SVG/AmbTemp.svg";
import { ReactComponent as unitIcon } from "../Assets/SVG/Unit_Small.svg";
import { ReactComponent as powerIcon } from "../Assets/SVG/Power_Small.svg";
import { ReactComponent as sensorIcon } from "../Assets/SVG/SensorType.svg";
import { allSitesAtom } from "../Atoms/allSitesAtom"; //"./Atoms/allSitesAtom";
import { useRecoilState } from "recoil";
import { useAuthenticator } from "@aws-amplify/ui-react";

const styles = {
  dashboardView: {
    flexGrow: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-start",
  },
  dashboardValue: {
    width: "50%",
  },
  overviewValue: {
    width: "100%",
  },
};

const ST4C = ({ children }) => (
  <View>
    {Children.map(children, (child, i) => {
      return <View key={i}>{child}</View>;
    })}
  </View>
);

export const ST4C_CH_ENUM = [
  "st4c_tC1",
  "st4c_tC2",
  "st4c_tC3",
  "st4c_tC4",
  "st4c_tAmb",
];

export const ST4C_CHANNEL_ICONS = [ch1Icon, ch2Icon, ch3Icon, ch4Icon, ambIcon];

export const ST4C_DEFAULT_Y_AXIS = (channels) => {
  let tempChannelArray = [];
  ST4C_CH_ENUM.forEach((channel) => {
    if (channels[channel]?.enabled) {
      tempChannelArray = _.concat(
        tempChannelArray,
        _.findIndex(ST4C_CH_ENUM, function (o) {
          return o == channel;
        })
      );
    }
  });
  return [
    {
      enabled: true,
      name: "Temperature Axis",
      channels: tempChannelArray,
      auto: true,
      min: 0,
      max: 100,
    },
  ];
};

export const ST4C_ENABLED_CHANNELS = (tool, addTS) => {
  let enabledChannels = [];
  if (addTS) enabledChannels.push("ts");
  if (tool.settings.channels.st4c_tC1.enabled)
    enabledChannels.push(ST4C_CH_ENUM[0]);
  if (tool.settings.channels.st4c_tC2.enabled)
    enabledChannels.push(ST4C_CH_ENUM[1]);
  if (tool.settings.channels.st4c_tC3.enabled)
    enabledChannels.push(ST4C_CH_ENUM[2]);
  if (tool.settings.channels.st4c_tC4.enabled)
    enabledChannels.push(ST4C_CH_ENUM[3]);
  if (tool.settings.channels.st4c_tAmb.enabled)
    enabledChannels.push(ST4C_CH_ENUM[4]);
  return enabledChannels;
};

export const ST4C_ENABLED_ARRAY = (tool, enabledChannels) => {
  let enabledArray = [];
  if (enabledChannels == null) {
    enabledArray = [
      tool.settings.channels.st4c_tC1.enabled,
      tool.settings.channels.st4c_tC2.enabled,
      tool.settings.channels.st4c_tC3.enabled,
      tool.settings.channels.st4c_tC4.enabled,
      tool.settings.channels.st4c_tAmb.enabled,
    ];
  } else {
    enabledArray.push(
      _.find(enabledChannels, function (o) {
        return o == "st4c_tC1";
      }) != undefined
    );
    enabledArray.push(
      _.find(enabledChannels, function (o) {
        return o == "st4c_tC2";
      }) != undefined
    );
    enabledArray.push(
      _.find(enabledChannels, function (o) {
        return o == "st4c_tC3";
      }) != undefined
    );
    enabledArray.push(
      _.find(enabledChannels, function (o) {
        return o == "st4c_tC4";
      }) != undefined
    );
    enabledArray.push(
      _.find(enabledChannels, function (o) {
        return o == "st4c_tAmb";
      }) != undefined
    );
  }

  return enabledArray;
};

export const ST4C_CONVERSION = (tool) => {
  let convertedSensor = {};
  let ch1Unit = tool.settings.channels.st4c_tC1.unit;
  let ch2Unit = tool.settings.channels.st4c_tC2.unit;
  let ch3Unit = tool.settings.channels.st4c_tC3.unit;
  let ch4Unit = tool.settings.channels.st4c_tC4.unit;
  let ambUnit = tool.settings.channels.st4c_tAmb.unit;

  //Convert CH1
  if (tool.sensor.st4c_tC1 == null) {
    convertedSensor.st4c_tC1 = null;
  } else {
    if (ch1Unit == ST4C_CHANNELS.st4c_tC1.unit.default) {
      //Default
      convertedSensor.st4c_tC1 = tool.sensor.st4c_tC1;
    } else {
      //Conversion needed
      if (ch1Unit == ST4C_CHANNELS.st4c_tC1.unit.enum[1]) {
        //F
        convertedSensor.st4c_tC1 = (tool.sensor.st4c_tC1 * 9) / 5 + 32;
      } else if (ch1Unit == ST4C_CHANNELS.st4c_tC1.unit.enum[2]) {
        //K
        convertedSensor.st4c_tC1 = tool.sensor.st4c_tC1 + 273.15;
      }
    }
  }
  //Convert CH2
  if (tool.sensor.st4c_tC2 == null) {
    convertedSensor.st4c_tC2 = null;
  } else {
    if (ch2Unit == ST4C_CHANNELS.st4c_tC2.unit.default) {
      //Default
      convertedSensor.st4c_tC2 = tool.sensor.st4c_tC2;
    } else {
      //Conversion needed
      if (ch2Unit == ST4C_CHANNELS.st4c_tC2.unit.enum[1]) {
        //F
        convertedSensor.st4c_tC2 = (tool.sensor.st4c_tC2 * 9) / 5 + 32;
      } else if (ch2Unit == ST4C_CHANNELS.st4c_tC2.unit.enum[2]) {
        //K
        convertedSensor.st4c_tC2 = tool.sensor.st4c_tC2 + 273.15;
      }
    }
  }
  //Convert CH3
  if (tool.sensor.st4c_tC3 == null) {
    convertedSensor.st4c_tC3 = null;
  } else {
    if (ch3Unit == ST4C_CHANNELS.st4c_tC3.unit.default) {
      //Default
      convertedSensor.st4c_tC3 = tool.sensor.st4c_tC3;
    } else {
      //Conversion needed
      if (ch3Unit == ST4C_CHANNELS.st4c_tC3.unit.enum[1]) {
        //F
        convertedSensor.st4c_tC3 = (tool.sensor.st4c_tC3 * 9) / 5 + 32;
      } else if (ch3Unit == ST4C_CHANNELS.st4c_tC3.unit.enum[2]) {
        //K
        convertedSensor.st4c_tC3 = tool.sensor.st4c_tC3 + 273.15;
      }
    }
  }
  //Convert CH4
  if (tool.sensor.st4c_tC4 == null) {
    convertedSensor.st4c_tC4 = null;
  } else {
    if (ch4Unit == ST4C_CHANNELS.st4c_tC4.unit.default) {
      //Default
      convertedSensor.st4c_tC4 = tool.sensor.st4c_tC4;
    } else {
      //Conversion needed
      if (ch4Unit == ST4C_CHANNELS.st4c_tC4.unit.enum[1]) {
        //F
        convertedSensor.st4c_tC4 = (tool.sensor.st4c_tC4 * 9) / 5 + 32;
      } else if (ch4Unit == ST4C_CHANNELS.st4c_tC4.unit.enum[2]) {
        //K
        convertedSensor.st4c_tC4 = tool.sensor.st4c_tC4 + 273.15;
      }
    }
  }
  //Convert Ambient
  if (tool.sensor.st4c_tAmb == null) {
    convertedSensor.st4c_tAmb = null;
  } else {
    if (ambUnit == ST4C_CHANNELS.st4c_tAmb.unit.default) {
      //Default
      convertedSensor.st4c_tAmb = tool.sensor.st4c_tAmb;
    } else {
      //Conversion needed
      if (ambUnit == ST4C_CHANNELS.st4c_tAmb.unit.enum[1]) {
        //F
        convertedSensor.st4c_tAmb = (tool.sensor.st4c_tAmb * 9) / 5 + 32;
      } else if (ambUnit == ST4C_CHANNELS.st4c_tAmb.unit.enum[2]) {
        //K
        convertedSensor.st4c_tAmb = tool.sensor.st4c_tAmb + 273.15;
      }
    }
  }

  return convertedSensor;
};

export const ST4C_GRAPH_CONVERSION = (tool, data, attributeArray) => {
  let tempData = _.cloneDeep(data);
  let ch1Unit = tool.settings.channels.st4c_tC1.unit;
  let ch2Unit = tool.settings.channels.st4c_tC2.unit;
  let ch3Unit = tool.settings.channels.st4c_tC3.unit;
  let ch4Unit = tool.settings.channels.st4c_tC4.unit;
  let ambUnit = tool.settings.channels.st4c_tAmb.unit;
  let ch1Idx = _.findIndex(attributeArray, function (o) {
    return o == ST4C_CH_ENUM[0];
  });
  let ch2Idx = _.findIndex(attributeArray, function (o) {
    return o == ST4C_CH_ENUM[1];
  });
  let ch3Idx = _.findIndex(attributeArray, function (o) {
    return o == ST4C_CH_ENUM[2];
  });
  let ch4Idx = _.findIndex(attributeArray, function (o) {
    return o == ST4C_CH_ENUM[3];
  });
  let ambIdx = _.findIndex(attributeArray, function (o) {
    return o == ST4C_CH_ENUM[4];
  });

  tempData.forEach((dataPoint) => {
    if (dataPoint[ch1Idx] != null) {
      if (ch1Unit != ST4C_CHANNELS.st4c_tC1.unit.default) {
        //Default
        if (ch1Unit == ST4C_CHANNELS.st4c_tC1.unit.enum[1]) {
          //F
          dataPoint[ch1Idx] = (dataPoint[ch1Idx] * 9) / 5 + 32;
        } else if (ch1Unit == ST4C_CHANNELS.st4c_tC1.unit.enum[2]) {
          //K
          dataPoint[ch1Idx] = dataPoint[ch1Idx] + 273.15;
        }
      }
    }
    if (dataPoint[ch2Idx] != null) {
      if (ch2Unit != ST4C_CHANNELS.st4c_tC2.unit.default) {
        //Default
        if (ch2Unit == ST4C_CHANNELS.st4c_tC2.unit.enum[1]) {
          //F
          dataPoint[ch2Idx] = (dataPoint[ch2Idx] * 9) / 5 + 32;
        } else if (ch2Unit == ST4C_CHANNELS.st4c_tC2.unit.enum[2]) {
          //K
          dataPoint[ch2Idx] = dataPoint[ch2Idx] + 273.15;
        }
      }
    }
    if (dataPoint[ch3Idx] != null) {
      if (ch3Unit != ST4C_CHANNELS.st4c_tC3.unit.default) {
        //Default
        if (ch3Unit == ST4C_CHANNELS.st4c_tC3.unit.enum[1]) {
          //F
          dataPoint[ch3Idx] = (dataPoint[ch3Idx] * 9) / 5 + 32;
        } else if (ch3Unit == ST4C_CHANNELS.st4c_tC3.unit.enum[2]) {
          //K
          dataPoint[ch3Idx] = dataPoint[ch3Idx] + 273.15;
        }
      }
    }
    if (dataPoint[ch4Idx] != null) {
      if (ch4Unit != ST4C_CHANNELS.st4c_tC4.unit.default) {
        //Default
        if (ch4Unit == ST4C_CHANNELS.st4c_tC4.unit.enum[1]) {
          //F
          dataPoint[ch4Idx] = (dataPoint[ch4Idx] * 9) / 5 + 32;
        } else if (ch4Unit == ST4C_CHANNELS.st4c_tC4.unit.enum[2]) {
          //K
          dataPoint[ch4Idx] = dataPoint[ch4Idx] + 273.15;
        }
      }
    }
    if (dataPoint[ambIdx] != null) {
      if (ambUnit != ST4C_CHANNELS.st4c_tAmb.unit.default) {
        //Default
        if (ambUnit == ST4C_CHANNELS.st4c_tAmb.unit.enum[1]) {
          //F
          dataPoint[ambIdx] = (dataPoint[ambIdx] * 9) / 5 + 32;
        } else if (ambUnit == ST4C_CHANNELS.st4c_tAmb.unit.enum[2]) {
          //K
          dataPoint[ambIdx] = dataPoint[ambIdx] + 273.15;
        }
      }
    }
  });
  return tempData;
};

const ST4C_CHANNELS = {
  st4c_tC1: {
    name: { type: "S", default: "Thermocouple Channel 1" },
    unit: { type: "E", default: "°C", enum: ["°C", "°F", "°K"] },
    sensorType: {
      type: "E",
      default: "K",
      enum: ["K", "J", "T", "E", "R", "S", "B", "N"],
    },
    enabled: { type: "B", default: true },
  },
  st4c_tC2: {
    name: { type: "S", default: "Thermocouple Channel 2" },
    unit: { type: "E", default: "°C", enum: ["°C", "°F", "°K"] },
    sensorType: {
      type: "E",
      default: "K",
      enum: ["K", "J", "T", "E", "R", "S", "B", "N"],
    },
    enabled: { type: "B", default: true },
  },
  st4c_tC3: {
    name: { type: "S", default: "Thermocouple Channel 3" },
    unit: { type: "E", default: "°C", enum: ["°C", "°F", "°K"] },
    sensorType: {
      type: "E",
      default: "K",
      enum: ["K", "J", "T", "E", "R", "S", "B", "N"],
    },
    enabled: { type: "B", default: true },
  },
  st4c_tC4: {
    name: { type: "S", default: "Thermocouple Channel 4" },
    unit: { type: "E", default: "°C", enum: ["°C", "°F", "°K"] },
    sensorType: {
      type: "E",
      default: "K",
      enum: ["K", "J", "T", "E", "R", "S", "B", "N"],
    },
    enabled: { type: "B", default: true },
  },
  st4c_tAmb: {
    name: { type: "S", default: "Ambient Temperature" },
    unit: { type: "E", default: "°C", enum: ["°C", "°F", "°K"] },
    enabled: { type: "B", default: true },
  },
};

ST4C.ToolDashboardContainer = ({ navigate, currentTool, selected }) => {
  let roundedTC1 =
    currentTool.convertedSensor.st4c_tC1 != "NC"
      ? Number(currentTool.convertedSensor.st4c_tC1).toFixed(1)
      : "--";
  let roundedTC2 =
    currentTool.convertedSensor.st4c_tC2 != "NC"
      ? Number(currentTool.convertedSensor.st4c_tC2).toFixed(1)
      : "--";
  let roundedTC3 =
    currentTool.convertedSensor.st4c_tC3 != "NC"
      ? Number(currentTool.convertedSensor.st4c_tC3).toFixed(1)
      : "--";
  let roundedTC4 =
    currentTool.convertedSensor.st4c_tC4 != "NC"
      ? Number(currentTool.convertedSensor.st4c_tC4).toFixed(1)
      : "--";
  let roundedTAmb =
    currentTool.convertedSensor.st4c_tAmb != "NC"
      ? Number(currentTool.convertedSensor.st4c_tAmb).toFixed(1)
      : "--";
  if (isNaN(roundedTC1)) roundedTC1 = "--";
  if (isNaN(roundedTC2)) roundedTC2 = "--";
  if (isNaN(roundedTC3)) roundedTC3 = "--";
  if (isNaN(roundedTC4)) roundedTC4 = "--";
  if (isNaN(roundedTAmb)) roundedTAmb = "--";
  let onPress;
  if (_.has(currentTool, "mac")) {
    onPress = () => navigate(`/site/${currentTool.mac}`);
  } else {
    onPress = () => navigate(`/site/${currentTool.share_id}`);
  }
  let usbPowered =
    _.has(currentTool, "toolSystem") && !_.isEmpty(currentTool.toolSystem)
      ? currentTool.toolSystem.sysPowerState == "USB"
      : undefined;
  let batteryLvl =
    _.has(currentTool, "toolSystem") &&
    !_.isEmpty(currentTool.toolSystem) &&
    currentTool.toolSystem.sysBatteryLvl
      ? currentTool.toolSystem.sysBatteryLvl
      : undefined;
  let cloudConnected = false;
  if (_.has(currentTool, "nextUpdateTS"))
    cloudConnected = HelperService.isCloudConnected(currentTool.nextUpdateTS);
  return (
    <Dashboard.Overview
      title={currentTool.settings.toolName}
      description={"ThermoSense"}
      shared={!_.has(currentTool, "mac")}
      symbol={toolIcon}
      usbPowered={usbPowered}
      batteryLvl={batteryLvl}
      cloudConnected={cloudConnected}
      onPress={onPress}
      alerts={currentTool.alerts}
      selected={selected}
    >
      {_.has(currentTool, "sensor") && !_.isEmpty(currentTool.sensor) ? (
        <ViewRow>
          {currentTool.settings.channels.st4c_tC1.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value={roundedTC1}
              units={
                roundedTC1 == "--"
                  ? ""
                  : currentTool.settings.channels.st4c_tC1.unit
              }
              label={currentTool.settings.channels.st4c_tC1.name}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tC2.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value={roundedTC2}
              units={
                roundedTC2 == "--"
                  ? ""
                  : currentTool.settings.channels.st4c_tC2.unit
              }
              label={currentTool.settings.channels.st4c_tC2.name}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tC3.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value={roundedTC3}
              units={
                roundedTC3 == "--"
                  ? ""
                  : currentTool.settings.channels.st4c_tC3.unit
              }
              label={currentTool.settings.channels.st4c_tC3.name}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tC4.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value={roundedTC4}
              units={
                roundedTC4 == "--"
                  ? ""
                  : currentTool.settings.channels.st4c_tC4.unit
              }
              label={currentTool.settings.channels.st4c_tC4.name}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tAmb.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value={roundedTAmb}
              units={
                roundedTAmb == "--"
                  ? ""
                  : currentTool.settings.channels.st4c_tAmb.unit
              }
              label={currentTool.settings.channels.st4c_tAmb.name}
            />
          ) : (
            <></>
          )}
        </ViewRow>
      ) : (
        <ViewRow>
          {currentTool.settings.channels.st4c_tC1.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value="--"
              units=""
              label={currentTool.settings.channels.st4c_tC1.name}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tC2.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value="--"
              units=""
              label={currentTool.settings.channels.st4c_tC2.name}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tC3.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value="--"
              units=""
              label={currentTool.settings.channels.st4c_tC3.name}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tC4.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value="--"
              units=""
              label={currentTool.settings.channels.st4c_tC4.name}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tAmb.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value="--"
              units=""
              label={currentTool.settings.channels.st4c_tAmb.name}
            />
          ) : (
            <></>
          )}
        </ViewRow>
      )}
    </Dashboard.Overview>
  );
};

ST4C.OverviewContainer = ({ currentTool, stats, enabled, setEnabled }) => {
  let fontSize = "xxlarge";
  let roundedTC1 =
    currentTool.convertedSensor.st4c_tC1 != "NC"
      ? Number(currentTool.convertedSensor.st4c_tC1).toFixed(1)
      : "--";
  let roundedTC2 =
    currentTool.convertedSensor.st4c_tC2 != "NC"
      ? Number(currentTool.convertedSensor.st4c_tC2).toFixed(1)
      : "--";
  let roundedTC3 =
    currentTool.convertedSensor.st4c_tC3 != "NC"
      ? Number(currentTool.convertedSensor.st4c_tC3).toFixed(1)
      : "--";
  let roundedTC4 =
    currentTool.convertedSensor.st4c_tC4 != "NC"
      ? Number(currentTool.convertedSensor.st4c_tC4).toFixed(1)
      : "--";
  let roundedTAmb =
    currentTool.convertedSensor.st4c_tAmb != "NC"
      ? Number(currentTool.convertedSensor.st4c_tAmb).toFixed(1)
      : "--";
  if (isNaN(roundedTC1)) roundedTC1 = "--";
  if (isNaN(roundedTC2)) roundedTC2 = "--";
  if (isNaN(roundedTC3)) roundedTC3 = "--";
  if (isNaN(roundedTC4)) roundedTC4 = "--";
  if (isNaN(roundedTAmb)) roundedTAmb = "--";
  const changeFontSize = () => {
    //xlarge 7-9 large 10, medium 11, 12-13 small, 14-15 hint
    if (
      roundedTC1.toString().length >= 14 ||
      roundedTC2.toString().length >= 14 ||
      roundedTC3.toString().length >= 14 ||
      roundedTC4.toString().length >= 14 ||
      roundedTAmb.toString().length >= 14
    ) {
      fontSize = "hint";
    } else if (
      roundedTC1.toString().length > 11 ||
      roundedTC2.toString().length > 11 ||
      roundedTC3.toString().length > 11 ||
      roundedTC4.toString().length > 11 ||
      roundedTAmb.toString().length > 11
    ) {
      fontSize = "small";
    } else if (
      roundedTC1.toString().length > 10 ||
      roundedTC2.toString().length > 10 ||
      roundedTC3.toString().length > 10 ||
      roundedTC4.toString().length > 10 ||
      roundedTAmb.toString().length > 10
    ) {
      fontSize = "medium";
    } else if (
      roundedTC1.toString().length > 9 ||
      roundedTC2.toString().length > 9 ||
      roundedTC3.toString().length > 9 ||
      roundedTC4.toString().length > 9 ||
      roundedTAmb.toString().length > 9
    ) {
      fontSize = "large";
    } else if (
      roundedTC1.toString().length > 6 ||
      roundedTC2.toString().length > 6 ||
      roundedTC3.toString().length > 6 ||
      roundedTC4.toString().length > 6 ||
      roundedTAmb.toString().length > 6
    ) {
      fontSize = "xlarge";
    }
  };
  return (
    <View>
      {_.has(currentTool, "sensor") && !_.isEmpty(currentTool.sensor) ? (
        <View style={styles.dashboardView}>
          {changeFontSize()}
          {currentTool.settings.channels.st4c_tC1.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              sensorType={currentTool.settings.channels.st4c_tC1.sensorType}
              size={fontSize}
              value={roundedTC1}
              units={
                roundedTC1 == "--"
                  ? ""
                  : currentTool.settings.channels.st4c_tC1.unit
              }
              label={currentTool.settings.channels.st4c_tC1.name}
              live={sensorLive.isLive(currentTool.sensor.updatedAt)}
              high={stats[0][0] != null ? stats[0][0].toFixed(1) : "--"}
              low={stats[0][1] != null ? stats[0][1].toFixed(1) : "--"}
              avg={stats[0][2] != null ? stats[0][2].toFixed(1) : "--"}
              icon={ch1Icon}
              color={enabled[0] ? channelColors[0] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={0}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tC2.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              sensorType={currentTool.settings.channels.st4c_tC2.sensorType}
              size={fontSize}
              value={roundedTC2}
              units={
                roundedTC2 == "--"
                  ? ""
                  : currentTool.settings.channels.st4c_tC2.unit
              }
              label={currentTool.settings.channels.st4c_tC2.name}
              live={sensorLive.isLive(currentTool.sensor.updatedAt)}
              high={stats[1][0] != null ? stats[1][0].toFixed(1) : "--"}
              low={stats[1][1] != null ? stats[1][1].toFixed(1) : "--"}
              avg={stats[1][2] != null ? stats[1][2].toFixed(1) : "--"}
              icon={ch2Icon}
              color={enabled[1] ? channelColors[1] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={1}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tC3.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              sensorType={currentTool.settings.channels.st4c_tC3.sensorType}
              size={fontSize}
              value={roundedTC3}
              units={
                roundedTC3 == "--"
                  ? ""
                  : currentTool.settings.channels.st4c_tC3.unit
              }
              label={currentTool.settings.channels.st4c_tC3.name}
              live={sensorLive.isLive(currentTool.sensor.updatedAt)}
              high={stats[2][0] != null ? stats[2][0].toFixed(1) : "--"}
              low={stats[2][1] != null ? stats[2][1].toFixed(1) : "--"}
              avg={stats[2][2] != null ? stats[2][2].toFixed(1) : "--"}
              icon={ch3Icon}
              color={enabled[2] ? channelColors[2] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={2}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tC4.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              sensorType={currentTool.settings.channels.st4c_tC4.sensorType}
              size={fontSize}
              value={roundedTC4}
              units={
                roundedTC4 == "--"
                  ? ""
                  : currentTool.settings.channels.st4c_tC4.unit
              }
              label={currentTool.settings.channels.st4c_tC4.name}
              live={sensorLive.isLive(currentTool.sensor.updatedAt)}
              high={stats[3][0] != null ? stats[3][0].toFixed(1) : "--"}
              low={stats[3][1] != null ? stats[3][1].toFixed(1) : "--"}
              avg={stats[3][2] != null ? stats[3][2].toFixed(1) : "--"}
              icon={ch4Icon}
              color={enabled[3] ? channelColors[3] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={3}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tAmb.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              size={fontSize}
              value={roundedTAmb}
              units={
                roundedTAmb == "--"
                  ? ""
                  : currentTool.settings.channels.st4c_tAmb.unit
              }
              label={currentTool.settings.channels.st4c_tAmb.name}
              live={sensorLive.isLive(currentTool.sensor.updatedAt)}
              high={stats[4][0] != null ? stats[4][0].toFixed(1) : "--"}
              low={stats[4][1] != null ? stats[4][1].toFixed(1) : "--"}
              avg={stats[4][2] != null ? stats[4][2].toFixed(1) : "--"}
              icon={ambIcon}
              color={enabled[4] ? channelColors[4] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={4}
            />
          ) : (
            <></>
          )}
        </View>
      ) : (
        <View style={styles.dashboardView}>
          {currentTool.settings.channels.st4c_tC1.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              sensorType={currentTool.settings.channels.st4c_tC1.sensorType}
              size={fontSize}
              value="--"
              units=""
              label={currentTool.settings.channels.st4c_tC1.name}
              live={false}
              high="--"
              low="--"
              avg="--"
              icon={ch1Icon}
              color={enabled[0] ? channelColors[0] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={0}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tC2.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              sensorType={currentTool.settings.channels.st4c_tC2.sensorType}
              size={fontSize}
              value="--"
              units=""
              label={currentTool.settings.channels.st4c_tC2.name}
              live={false}
              high="--"
              low="--"
              avg="--"
              icon={ch2Icon}
              color={enabled[1] ? channelColors[1] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={1}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tC3.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              sensorType={currentTool.settings.channels.st4c_tC3.sensorType}
              size={fontSize}
              value="--"
              units=""
              label={currentTool.settings.channels.st4c_tC3.name}
              live={false}
              high="--"
              low="--"
              avg="--"
              icon={ch3Icon}
              color={enabled[2] ? channelColors[2] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={2}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tC4.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              sensorType={currentTool.settings.channels.st4c_tC4.sensorType}
              size={fontSize}
              value="--"
              units=""
              label={currentTool.settings.channels.st4c_tC4.name}
              live={false}
              high="--"
              low="--"
              avg="--"
              icon={ch4Icon}
              color={enabled[3] ? channelColors[3] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={3}
            />
          ) : (
            <></>
          )}
          {currentTool.settings.channels.st4c_tAmb.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              size={fontSize}
              value="--"
              units=""
              label={currentTool.settings.channels.st4c_tAmb.name}
              live={false}
              high="--"
              low="--"
              avg="--"
              icon={ambIcon}
              color={enabled[4] ? channelColors[4] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={4}
            />
          ) : (
            <></>
          )}
        </View>
      )}
    </View>
  );
};

export const ST4CChannelContainer = ({ currentTool, channelKey }) => {
  const [chError, setChError] = useState(true);
  const [allSites, setAllSites] = useRecoilState(allSitesAtom);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  // try {
  // const dispatch = useDispatch()
  const units = ST4C_CHANNELS.st4c_tC1.unit.enum;
  const sensorTypes = ST4C_CHANNELS.st4c_tC1.sensorType.enum;
  const [chName, setChName] = useState(
    _.get(currentTool.settings.channels, channelKey).name
  );
  const [chEn, setChEn] = useState(
    _.get(currentTool.settings.channels, channelKey).enabled
  );
  const [chEnTool, setChEnTool] = useState(
    _.get(currentTool.toolSettings.channels, channelKey).enabled
  );
  const [chEnTime, setChEnTime] = useState(true);
  const [chUnit, setChUnit] = useState(
    _.get(currentTool.settings.channels, channelKey).unit
  );
  const [chSensorType, setChSensorType] = useState(
    _.get(currentTool.settings.channels, channelKey).sensorType
  );
  const [chSensorTypeTool, setChSensorTypeTool] = useState(
    _.get(currentTool.toolSettings.channels, channelKey).sensorType
  );
  const [chSensorTypeTime, setChSensorTypeTime] = useState(true);
  let graphData = allSites.graphData;
  let index = _.indexOf(ST4C_CH_ENUM, channelKey);
  let tempGraphProps = currentTool.settings.graphPropsDashboard;
  let tempChannels = _.cloneDeep(currentTool.settings.channels);

  useEffect(() => {
    console.log("Channel Key or Tool Changed!");
    setChName(_.get(currentTool.settings.channels, channelKey).name);
    setChEn(_.get(currentTool.settings.channels, channelKey).enabled);
    setChEnTime(true);
    setChUnit(_.get(currentTool.settings.channels, channelKey).unit);
    setChEnTool(_.get(currentTool.toolSettings.channels, channelKey).enabled);
    setChSensorTypeTool(
      _.get(currentTool.toolSettings.channels, channelKey).sensorType
    );
  }, [currentTool, channelKey]);

  function updateSettings(object, pullAfter) {
    updateToolSettings(currentTool, object).then(async () => {
      if (pullAfter) {
        await HelperService.delayMs(1000);
        getSettings(currentTool);
      }
    });
  }
  async function getSettings(object) {
    console.log("updated Settings SDP1:", object);
    let settings = await getToolSettings(currentTool, object).then(
      (settings) => settings
    );
    let tempAllSites = _.cloneDeepWith(allSites);
    let mac = currentTool?.mac ? currentTool.mac : currentTool.share_id;
    tempAllSites[mac].settings = settings.settings;
    tempAllSites[mac].toolSettings = settings.toolSettings;
    tempAllSites[mac].toolSystem = settings.toolSystem;
    setAllSites(tempAllSites);
  }

  const timer0 = useRef(null);
  const timer1 = useRef(null);

  async function updateChEnTime() {
    clearTimeout(timer0.current);
    timer0.current = null;
    setChEnTime(false);
    timer0.current = setTimeout(async () => {
      getSettings(currentTool);
      await HelperService.delayMs(1000);
      setChEnTime(true);
    }, toolSyncTime - 1000);
  }
  async function updateChSensorTypeTime() {
    clearTimeout(timer1.current);
    timer1.current = null;
    setChSensorTypeTime(false);
    timer1.current = setTimeout(async () => {
      getSettings(currentTool);
      await HelperService.delayMs(1000);
      setChSensorTypeTime(true);
    }, toolSyncTime - 1000);
  }
  return (
    <View>
      <Row.Toggle //Enable/Disable
        title="Status"
        icon={powerIcon}
        value={chEn}
        toolValue={chEnTool}
        syncTime={chEnTime}
        tool={currentTool}
        getSettings={getSettings}
        onValueChange={(value) => {
          setChEn(value);
          tempChannels[channelKey].enabled = value;
          if (!_.isEmpty(tempGraphProps))
            tempGraphProps.enY = ST4C_DEFAULT_Y_AXIS(tempChannels);
          updateSettings(
            {
              channels: { [channelKey]: { enabled: value } },
              graphPropsDashboard: tempGraphProps,
            },
            false
          );
          updateChEnTime();
          //UPDATE GRAPH DATA
          let tempGraphData = _.cloneDeep(graphData);
          tempGraphData.delete(currentTool.data_id);
          // dispatch(ToolActions.addToolGraphDataToStore(tempGraphData,null,null))//Clear data
          //TODO reload data
        }}
      />
      <Row.Setting //Name
        title="Channel Name"
        setting={chName}
        icon={ST4C_CHANNEL_ICONS[index]}
        color={channelColors[index]}
        changeSetting={setChName}
        setSetting={() =>
          updateSettings({ channels: { [channelKey]: { name: chName } } }, true)
        }
      />
      <Row.Picker //Unit
        title="Unit"
        icon={unitIcon}
        values={units}
        value={chUnit}
        setValue={setChUnit}
        onPress={(value) => {
          setChUnit(value);
          tempChannels[channelKey].unit = value;
          if (!_.isEmpty(tempGraphProps))
            tempGraphProps.enY = ST4C_DEFAULT_Y_AXIS(tempChannels);
          updateSettings(
            {
              channels: { [channelKey]: { unit: value } },
              graphPropsDashboard: tempGraphProps,
            },
            true
          );
          //UPDATE GRAPH DATA
          let tempGraphData = graphData;
          tempGraphData.delete(currentTool.data_id);
          // dispatch(ToolActions.addToolGraphDataToStore(tempGraphData,null,null))//Clear data
        }}
      />
      {channelKey != "st4c_tAmb" ? (
        <Row.Picker //SensorType
          title="Sensor Type"
          icon={sensorIcon}
          values={sensorTypes}
          value={chSensorType}
          setValue={setChSensorType}
          toolValue={chSensorTypeTool}
          syncTime={chSensorTypeTime}
          tool={currentTool}
          getSettings={getSettings}
          onPress={(value) => {
            setChSensorType(value);
            tempChannels[channelKey].sensorType = value;
            if (!_.isEmpty(tempGraphProps))
              tempGraphProps.enY = ST4C_DEFAULT_Y_AXIS(tempChannels);
            updateSettings(
              {
                channels: { [channelKey]: { sensorType: value } },
                graphPropsDashboard: tempGraphProps,
              },
              false
            );
            updateChSensorTypeTime();
          }}
        />
      ) : (
        <></>
      )}
    </View>
  );
  // } catch (error) {
  //     return(
  //       <View>
  //         <Alert visible={chError} setVisible={setChError} title="Error: Channel Setting Mismatch"
  //         text={"Unable to display Tool's channel settings. Please update your Tool's firmware to resolve this issue."} oneButton={true}
  //         onPress={async ()=>{
  //           setChError(false)
  //         }}/>
  //       </View>
  //       )
  //   }
};

export default ST4C;
